import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {PipelineTemplate} from "../types.ts";
import {usePipelineTemplate} from "../hooks/usePipelineTemplate.ts";


export const AddFormDrawer = (props: DrawerProps) => {

    const {
        record,
        createRecord,
    } = usePipelineTemplate();

    return (
        <FormDrawer
            record={record ?? {} as PipelineTemplate}
            handleSubmit={createRecord}
            {...props}
        />
    )
};
